import DuraflowCategoryPage from '@/pages/equipamentos-e-componentes/components/DuraflowCategoryPage';
import useSeo from '@/hooks/useSeo';

export default function BombasPage() {
  useSeo({
    title: 'Bombas Hidráulicas Industriais | Duraflow',
    description: 'Bombas de pistão, engrenagem, palheta e unidades hidráulicas compactas para reposição, manutenção e novos projetos industriais.',
    keywords: 'bombas hidráulicas, bombas de pistão, bombas de engrenagem, componentes hidráulicos, DURAFLOW, Grupo Pilar',
    canonical: 'https://www.pilarmanutencao.com.br/bombas-hidraulicas',
    ogUrl: 'https://www.pilarmanutencao.com.br/bombas-hidraulicas',
    ogImage: '/images/EQUIPAMENTOS-E-COMPONENTES/NOSSOS-PRODUTOS/BOMBAS-HIDRAULICAS/CARD/BOMBAS-HIDRAULICAS.webp',
  });

  return (
    <DuraflowCategoryPage
      title="Bombas Hidráulicas"
      subtitle="Fornecimento de bombas hidráulicas para reposição, manutenção e novos projetos industriais."
      heroImage="/images/EQUIPAMENTOS-E-COMPONENTES/NOSSOS-PRODUTOS/BOMBAS-HIDRAULICAS/HERO/HERO-BOMBAS-HIDRAULICAS.webp"
      heroImageAlt="Bombas hidráulicas industriais de alta performance"
      description="Bombas hidráulicas são responsáveis por transformar energia mecânica em fluxo hidráulico. Elas alimentam o sistema com óleo pressurizado, permitindo o acionamento de cilindros, motores, válvulas e atuadores."
      applications={[
        'Bombas de engrenagem',
        'Bombas de pistão',
        'Bombas de palheta',
        'Bombas duplas',
        'Bombas para unidades hidráulicas',
        'Bombas para máquinas móveis',
        'Bombas para sistemas industriais',
        'Reposição e equivalência técnica sob consulta',
      ]}
      applicationsTitle="Soluções atendidas"
      types={[
        {
          title: 'Bombas de Engrenagem',
          description:
            'Bombas de engrenagem externa e interna para aplicações que exigem custo-benefício, simplicidade e confiabilidade em sistemas de média pressão.',
        },
        {
          title: 'Bombas de Palhetas',
          description:
            'Bombas de palhetas de deslocamento fixo e variável, com baixo nível de ruído e excelente rendimento volumétrico para aplicações sensíveis.',
        },
        {
          title: 'Bombas de Pistão Axial',
          description:
            'Bombas de pistão axial de alta performance, com deslocamento variável e controle de pressão para sistemas de alta demanda energética.',
        },
        {
          title: 'Bombas de Pistão Radial',
          description:
            'Bombas de pistão radial para aplicações que exigem altas pressões e múltiplos circuitos independentes em um único eixo.',
        },
        {
          title: 'Bombas de Engrenagem Interna',
          description:
            'Bombas de engrenagem interna com baixa pulsão de fluxo, ideais para sistemas que requerem fluidez e precisão no controle de atuadores.',
        },
        {
          title: 'Unidades Hidráulicas Compactas',
          description:
            'Mini centrais hidráulicas compactas com bomba, motor, reservatório e válvulas integradas para aplicações pontuais e móveis.',
        },
      ]}
      differentials={[
        'Atendimento técnico especializado',
        'Fornecimento sob consulta',
        'Apoio na identificação de componentes',
        'Análise da aplicação',
        'Alternativas compatíveis',
        'Cotação rápida via WhatsApp',
        'Suporte para manutenção industrial',
        'Soluções para reposição e novos projetos',
      ]}
      differentialsTitle="Diferenciais Duraflow"
      midCTA={{
        title: 'Precisa identificar ou cotar uma bomba hidráulica?',
        text: 'Envie o código, foto da plaqueta ou dados da aplicação para análise técnica.',
        buttonText: 'Enviar dados da bomba',
      }}
      ctaTitle="Precisa de uma solução hidráulica?"
      ctaText="Envie sua demanda para nossa equipe técnica. Podemos ajudar na identificação, cotação e fornecimento do componente mais adequado para sua aplicação."
      ctaButtonText="Chamar no WhatsApp"
    />
  );
}